import { z } from "zod";
import { STAGE_TYPES } from "#app/lib/data";
import { stageTypeLabel } from "#app/lib/entity-visuals";

/** The one Stage category a tile counts: Not started, In progress, Completed
 *  or Canceled. The widget's type id stays `projects-closed` (a persisted row
 *  key and a server allowlist entry) from the days it counted the terminal
 *  pair alone; "closed" is code vocabulary and never a word a member sees. */
export const stageCategorySchema = z.enum(STAGE_TYPES);
export type StageCategory = z.infer<typeof stageCategorySchema>;

/** "Projects completed", "Projects in progress" — the noun first, then the
 *  category's display label (through `stageTypeLabel`, never the enum word)
 *  in running-text case. Noun-first is the pattern the gallery's other
 *  participle labels already use ("Projects created", "Projects updated"),
 *  and it reads naturally for all four categories where "In progress
 *  Projects" did not. */
export function categoryProjectsLabel(category: StageCategory): string {
  return `Projects ${(stageTypeLabel(category) ?? category).toLowerCase()}`;
}
